import React from "react";
import { Helmet } from "react-helmet";
import CountryMap from "../components/countryMap";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import contactBanner from "../images/conact-us-2-.jpg";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>AFRO || Contact US</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground="image"
        videoURL=""
        imageURL=""
        staticImageURL={contactBanner}
      >
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            Contact Us
          </h1>
        </div>
      </Header>
      <main className="pt-13 pb-13">
        <CountryMap />
      </main>
      <Footer />
    </>
  );
};

export default Contact;
